import { RxCustomerAPI } from '@driftt/dapper'
import { List } from 'immutable'
import { encodeQueryData } from 'utils/Helpers'

import { parseSegment } from 'app/modules/segment/models'

export const api = {
  fetchList() {
    return RxCustomerAPI
      .get('/user_lists')
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(segments => List(segments).map(parseSegment))
  },

  fetchSegmentSetCardinality(userListIds) {
    return RxCustomerAPI
      .get(`/user_lists/member-cardinality?${encodeQueryData({ userListIds: userListIds.toJS() })}`)
      .checkStatus()
      .retryWithBackoff()
  },
  fetchEndUserMembership(endUserId, orgId) {
    return RxCustomerAPI
      .get(`/end_users/${endUserId}/memberships?orgId=${orgId}`)
      .checkStatus()
      .retryWithBackoff()
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/segment/api.js